import React from 'react';
import { pricing } from '../data/content';
import { formatArs } from '../utils/format';
export function FinalCta() {
  return <section className="w-full bg-cream-deep" data-id="element-100" data-mp="vghhfpe10dp0">
      <div className="mx-auto max-w-content px-5 py-16 text-center lg:px-8 lg:py-24" data-id="element-101" data-mp="19ez19c0t961n">
        <h2 className="mx-auto max-w-3xl font-display text-3xl font-black leading-tight text-ink sm:text-4xl lg:text-5xl" data-id="element-102" data-mp="19cmac9d2rlcg">
          Ordená tus cuentas. Protegé tu dinero. Construí tus ahorros.
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-lg leading-relaxed text-ink-muted" data-id="element-103" data-mp="1jase6wifz1jy">
          Accedé al Sistema de Ahorro: El Método de los 4 Bolsillos y empezá hoy
          con el primer paso.
        </p>

        <div className="mt-9 flex flex-col items-center gap-4" data-id="element-104" data-mp="1o3vavdiimr4d">
          <a href="#comprar" className="inline-flex items-center justify-center rounded-lg bg-forest px-8 py-4 font-display text-base font-extrabold uppercase tracking-wide text-cream transition-colors duration-150 ease-out hover:bg-forest-soft" data-id="element-105" data-mp="1o4n26c52y2ou">
            Acceder por {formatArs(pricing.price)} {pricing.currency}
          </a>
          <p className="text-sm text-ink-muted" data-id="element-106" data-mp="s4pefvii8qe2">
            Pago único · Acceso inmediato · Garantía de 7 días
          </p>
        </div>
      </div>
    </section>;
}